<template>
	<div id="app">
		<!-- Views -->
		<div class="flex wrap xs-12" v-if="!nonexistentSettings">
			<!-- Side Menu static position width 200px -->
			<core-main-menu v-if="shouldBeDisplayed" />

			<!-- Content -->
			<div
				class="main-content"
				:class="{ 'main-content--no-side-menu': !shouldBeDisplayed }"
			>
				<!-- Top Bar has full width -->
				<core-top-bar v-if="shouldBeDisplayed" />

				<!-- Content full width -->
				<div>
					<router-view />
				</div>

				<!-- Menu button on mobile -->
				<div class="menu-button" @click="toggleMenu" v-if="shouldBeDisplayed">
					{{ $t("menu") }}
				</div>
			</div>
		</div>

		<!-- If tenant settings doesn't exist -->
		<page-error v-if="nonexistentSettings" />

		<!-- Messaging -->
		<j-message
			:messages="messages"
			:max="1"
			:zIndex="1000"
			@click="removeMessage($event)"
		/>

		<!-- Global loading spinner -->
		<div class="spinner" v-if="loading.length">
			<div class="flex xs-12 wrap">
				<div class="flex xs-12 xs-center xs-middle">
					<j-spinner size="large" />
				</div>
				<div class="xs-12 ta2 mt4 fs4 fw7">
					{{ $t("login.loading") }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import "@/assets/css/index.css"
import JMessage from "@/components/JMessage"
import JSpinner from "@/components/JSpinner"
import PageError from "@/pages/Error"
import CoreMainMenu from "@/modules/core/components/CoreMainMenu"
import CoreTopBar from "@/modules/core/components/CoreTopBar"
import { mapState } from "vuex"

export default {
	name: "App",
	components: { JMessage, JSpinner, PageError, CoreMainMenu, CoreTopBar },
	computed: {
		...mapState(["messages", "loading", "isReady", "nonexistentSettings"]),

		// For some routes, don't display main menu and top bar
		shouldBeDisplayed() {
			const name = this.$route.name || null

			if (
				name === "login" ||
				name === "reset-password" ||
				name === "forgotten-password" ||
				name === "new-password"
			)
				return false
			else return true
		}
	},

	methods: {
		removeMessage(message) {
			this.$store.commit("REMOVE_MESSAGE", message)
		},

		toggleMenu() {
			this.$store.commit("SET_MENU", !this.$store.state.isMenuVisible)
		}
	},

	created() {
		// When app is created, get tenantId from URL
		if (this.$route.params.tenantId)
			this.$store.commit("UPDATE_TENANT_ID", this.$route.params.tenantId)
	}
}
</script>

<style scoped>
@import "./assets/css/tokens.css";

.main-content {
	width: 100%;
}

.spinner {
	position: fixed;
	top: 0;
	left: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100vw;
	height: 100vh;
	background: var(--color4-alpha-90);
	z-index: 999;
	cursor: auto;
}

.menu-button {
	position: fixed;
	bottom: 8px;
	right: 8px;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 56px;
	height: 56px;
	border-radius: 100%;
	background-color: var(--color2);
	color: var(--color5);
	font-size: var(--fontSize3);
	font-weight: var(--fontWeight7);
	user-select: none;
	cursor: pointer;
	z-index: 101;
}

@media (--md) {
	.main-content {
		width: calc(100% - 180px);
		margin-left: 180px;
	}

	.main-content--no-side-menu {
		width: 100%;
		margin-left: 0;
	}

	.menu-button {
		display: none;
	}
}
</style>
